import db from '../../db';
import {
    getImputationsByDay, getImputationInProgressByDay, loadImputationsByDay
} from '../imputations/imputationsActions'
import { loadActiveUser } from "../users/usersActions";
import { throwSuccessMessage, throwErrorMessage } from '../../lib/error_helper';
import { castImputationForServerFormat } from '../imputations/imputationsCast'
import { VALIDATE_DAY, ERROR } from './dayConstants'
import { getCurrentDate, getDayString } from '../../time';
import {
    createOrGetDayByDate, is_modification_authorized, fillCurrentState,
    validateDaySendDataIsLoading, validateDaySendDataSuccess,
    validateDaySendDataHasErrored, is_validation_authorized, fetchActiveDayAction
} from './dayActions.js';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';

// Initialise les jours de J à J-3
// Supprime les journées supérieures à 31 jours
export function initializeDays(userId) {
    return () => {
        let today = getCurrentDate()
        return db.transaction("rw?", db.Day, db.User, async () => {
            // Ajout des nouvelles journées (si manquantes)
            let nbDays = 3;
            while (nbDays >= 0) {
                let currentDate = getCurrentDate();
                currentDate.setDate(today.getDate() - nbDays);
                await createOrGetDayByDate(userId, getDayString(currentDate), true);

                nbDays -= 1
            }
            //suppression des imputations vielles de plus de 31 jours
            let dateToDelete = getCurrentDate();
            dateToDelete.setDate(today.getDate() - 31);
            await db.Day.where('date').below(getDayString(dateToDelete)).delete();

        }).then(async () => {
            // On retourne "Aujourd'hui"
            return await createOrGetDayByDate(userId, getDayString(today))
        }).catch((e) => {
            console.error("dayEditionActions - initializeDays");
            throw e;
        });
    }
}

//démarrage du jour
export function startDay(day) {
    return async (dispatch) => {
        return new Promise((resolve) => {
            return db.transaction("rw?", db.Day, db.Imputation, async () => {

                let returnedModificationAndImputation = {
                    modification: null,
                    imputation: null,
                };

                db.Day.update(day.id, { active: true }).then(async () => {
                    returnedModificationAndImputation.modification = await is_modification_authorized(day);

                    // let validation = await is_validation_authorized(day);

                    let imputations = await getImputationInProgressByDay(day.id);
                    dispatch(fillCurrentState(imputations)).then(currentImputation => {
                        if (currentImputation) {
                            returnedModificationAndImputation.imputation = currentImputation;
                        }

                        dispatch(loadImputationsByDay(day.id));

                        return resolve(returnedModificationAndImputation);
                    })
                })
            });
        })
    }
}

export async function createDayInDb(day) {
    return await db.transaction("rw?", db.Day, db.User, async () => {
        let test = await createOrGetDayByDate(day.user_id, day.date);
        if ((test === null || (test !== null && test.day === null)) && day !== null) {
            return await db.Day.add(day).then(async (id) => {
                day.id = id;
                return day;
            }).catch((e) => {
                console.error("Erreur de création du jour : " + day);
                throw e;
            });
        } else {
            return test;
        }
    }).catch((e) => {
        console.error("Erreur de création du jour : " + day);
        throw e;
    });
}

export function validateDay(day, user) {
    return async (dispatch) => {
        await db.transaction("rw?", db.Day, db.Imputation, db.User, async () => {
            await db.Day.update(day.id, { validation: true }).then(async () => {
                let updated_day = Object.assign({}, day);
                updated_day.validation = true;
                day.validation = true;

                dispatch({ type: VALIDATE_DAY, payload: updated_day });

            }).catch((err) => {
                console.error("Erreur : dayEditionActions - validateDay")
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la validation de la journée !",
                }));
                dispatch({ type: ERROR, error: err });
            })
        }).then(async () => {
            let imputations = await getImputationsByDay(day.id);
            dispatch(validateDaySendData(day, imputations.map(imputation => castImputationForServerFormat(imputation, user))));
        }).catch((err) => {
            console.error("Erreur : dayEditionActions - ValidateDay")
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la validation de la journée !",
            }));
            dispatch({ type: ERROR, error: err });
        });
    }
}

export function validateDayOnly(day) {
    return async (dispatch) => {
        await db.transaction("rw?", db.Day, db.Imputation, db.User, async () => {
            await db.Day.update(day.id, { validation: true }).then(async () => {
                let updated_day = Object.assign({}, day);
                updated_day.validation = true;
                day.validation = true;

                dispatch({ type: VALIDATE_DAY, payload: updated_day });

            }).catch((err) => {
                console.error("Erreur : dayEditionActions - validateDayOnly")
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la validation de la journée !",
                }));
                dispatch({ type: ERROR, error: err });
            })
        }).catch((err) => {
            console.error("Erreur : dayEditionActions - validateDayOnly " + err.message)
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la validation de la journée !",
            }));
            dispatch({ type: ERROR, error: err });
        });
    }
}

export function unvalidateDay(id) {
    db.Day.update(id, { validation: false })
        .catch(() => {
            console.error("Erreur : dayEditionActions - unvalidateDay");
        })
}

export async function deleteDay(id) {
    await db.Day.delete(id).then(async () => {
        console.error('suppression : ' + id);
    }).catch((e) => {
        console.error('suppression échouée : ' + e);
        throw e;
    });
}

export function validateDaySendData(day, imputations) {
    return (dispatch) => {
        dispatch(validateDaySendDataIsLoading(true));
        loadActiveUser()((userAct) => {
            const headers = new Headers({ 'Content-Type': 'application/json' });
            const body = JSON.stringify({
                user_id: userAct.user.id,
                empId: userAct.user.emp_id,
                day: day.date,
                imputations: imputations
            });
            fetchWithTimeout('/api/v1/valide_day', {
                method: 'POST',
                headers: headers,
                body: body,
                timeout: 60000,
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 400) {
                            response.json().then((err) => {
                                dispatch(throwErrorMessage({
                                    errorObject: err,
                                    title: "Erreur",
                                    message: err.message,
                                }))
                            })

                        }
                        else {
                            throw Error(response.statusText);
                        }
                    } else {
                        dispatch(validateDaySendDataSuccess(day));
                        dispatch(throwSuccessMessage({
                            title: "Validation effectuée",
                            message: 'La validation de la journée est effectuée.',
                            dismissAfter: 3000
                        }))
                    }
                })
                .catch((err) => {
                    console.error("Erreur : dayEditionActions - validateDaySendData", err)
                    dispatch(throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: err.message ?? 'Une erreur est survenue lors de la validation de la journée.',
                    }))
                    dispatch(validateDaySendDataHasErrored(true))
                });
        });
    };
}

export function setActiveDay(day) {
    return async (dispatch) => {
        await db.Day.toCollection().modify({ active: false }).then(async () => {
            await db.Day.update(day.id, { active: true }).then(async () => {
                let updated_day = day;
                updated_day.active = true;

                let isValidationAuthorized = await is_validation_authorized(day);
                let isModificationAuthorized = await is_modification_authorized(day);
                dispatch(fetchActiveDayAction(day, isValidationAuthorized, isModificationAuthorized));
            }).catch((e) => {
                console.error("Erreur : dayEditionActions - setActiveDay")
                throw e;
            });
        }).catch((e) => {
            console.error("Erreur : dayEditionActions - setActiveDay")
            throw e;
        });
    }
}
